import Typography from "@material-ui/core/Typography";
import React from "react";

const Copyright = () => {
    return (
        <Typography variant="body2" color="textSecondary" align="center">
            ©{new Date().getFullYear()} DQ LAB Pte Ltd. All rights reserved. Powered by DQ® is a registered trademark of DQ LAB Pte Ltd.
        </Typography>
    );
}

export default Copyright;